const apikey = process.env.REACT_APP_API_MAP_YANDEX;
const defaultState = {
    center: [56.838011, 60.597465],
    zoom: 12,
};

export {
    apikey,
    defaultState,
}